import { apiClient } from '@/provider';
import { prepareSchema } from '@/provider/utils';
import managementItemScheme from './management-item.graphql';

const SCHEME_NAME_PREFIX = 'PixelMonitor Object Management Item, ';
const addNamePrefix = name => `${SCHEME_NAME_PREFIX}${name}`;

export default {
  fetchBaseManagementItemSchemaId() {
    return apiClient
      .query({
        query: managementItemScheme.fetchBaseManagementItemSchemaId
      })
      .then(r => r.data.schemata[0]?.id || '');
  },
  async fetch(id) {
    const res = await apiClient.query({
      query: managementItemScheme.fetch,
      variables: {
        id
      },
      fetchPolicy: 'no-cache'
    });
    return prepareSchema(res.data.schema);
  },
  create({ name, schemaId, parentSchemaId, description }) {
    return apiClient
      .mutate({
        mutation: managementItemScheme.create,
        variables: {
          input: {
            newSchemaName: addNamePrefix(name),
            newSchemaDescription: description,
            schemaId,
            newSchemaTags: ['application', 'monitor', 'object management item'],
            linkToSchemaId: parentSchemaId
          }
        }
      })
      .then(r => r.data?.createSchemaCopy?.uuid);
  },

  update(id, { name, description }) {
    return apiClient.mutate({
      mutation: managementItemScheme.update,
      variables: {
        id,
        name: addNamePrefix(name),
        description
      }
    });
  }
};
